import { render, staticRenderFns } from "./Transference.vue?vue&type=template&id=4f89c378&scoped=true"
import script from "./Transference.vue?vue&type=script&lang=js"
export * from "./Transference.vue?vue&type=script&lang=js"
import style0 from "./Transference.vue?vue&type=style&index=0&id=4f89c378&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f89c378",
  null
  
)

export default component.exports